/* PDP enhancements — buy box behaviour
   Upload to Shopify as: assets/pdp-enhancements.js */
(function () {
  function bindWishlist(btn) {
    if (btn.__wishBound) return;
    btn.__wishBound = 1;
    btn.addEventListener('click', function () {
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', (!pressed).toString());
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 170);
    });
  }

  function bindLiveShoppers(root) {
    if (root.__lsBound) return;
    root.__lsBound = 1;
    var pid = root.getAttribute('data-product-id') || '0';
    var vOut = root.querySelector('[data-v-out]');
    var cOut = root.querySelector('[data-c-out]');
    var c = parseInt(root.getAttribute('data-c'), 10) || 1;
    var d = new Date();
    var ymd = d.getFullYear().toString() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
    var key = 'p' + pid + '-' + ymd;
    fetch('https://abacus.jasoncameron.dev/hit/beachai-pdp/' + key)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (vOut && data && typeof data.value === 'number') { vOut.textContent = data.value; }
      })
      .catch(function () { });
    setInterval(function () {
      if (Math.random() < 0.18) {
        c = Math.max(1, Math.min(9, c + (Math.random() < 0.5 ? -1 : 1)));
        if (cOut) cOut.textContent = c;
      }
    }, 28000 + Math.floor(Math.random() * 9000));
  }

  function syncStockPill() {
    document.querySelectorAll('[data-stock]').forEach(function (row) {
      var urg = row.querySelector('.pdp__urgency-badge');
      var instock = row.querySelectorAll('.pdp__instock');
      var hasUrg = urg && (urg.textContent || '').trim() !== '' && getComputedStyle(urg).display !== 'none';
      instock.forEach(function (el) { el.style.display = hasUrg ? 'none' : ''; });
    });
  }

  function initMobileAtcBar() {
    var bar = document.querySelector('[data-pdp-matc]');
    if (!bar) return;
    var atc = document.querySelector('[data-add-to-cart]');
    var btn = bar.querySelector('[data-matc-atc]');
    if (btn && atc) { btn.addEventListener('click', function () { if (!atc.disabled) atc.click(); }); }
    var buy = document.querySelector('.pdp__col--buy');
    if (!buy) return;
    bar.removeAttribute('hidden');
    bar.removeAttribute('aria-hidden');
    function check() {
      if (window.innerWidth >= 861) { bar.classList.remove('is-visible'); return; }
      var rect = buy.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function initHoverZoom() {
    if (window.innerWidth < 1200) return;
    var box = document.querySelector('.pdp__stack-box');
    if (!box) return;
    var img = box.querySelector('.pdp__stack-img');
    if (!img) return;
    var z = document.createElement('div');
    z.className = 'pdp__hzoom';
    document.body.appendChild(z);
    function move(e) {
      var r = img.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      z.style.backgroundImage = 'url("' + img.currentSrc + '")';
      z.style.backgroundPosition = x + '% ' + y + '%';
    }
    box.addEventListener('mouseenter', function () { z.classList.add('is-visible'); });
    box.addEventListener('mousemove', move);
    box.addEventListener('mouseleave', function () { z.classList.remove('is-visible'); });
  }

  function initGalleryArrows() {
    var box = document.querySelector('.pdp__stack-box');
    if (!box) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp__stack-thumb'));
    if (thumbs.length < 2) return;
    function arrow(dir, label, points) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp__stack-arrow pdp__stack-arrow--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="' + points + '"/></svg>';
      return b;
    }
    var prev = arrow('prev', 'Previous image', '15 18 9 12 15 6');
    var next = arrow('next', 'Next image', '9 18 15 12 9 6');
    function curIdx() {
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) return i; }
      return 0;
    }
    prev.addEventListener('click', function () { var i = curIdx(); thumbs[(i - 1 + thumbs.length) % thumbs.length].click(); });
    next.addEventListener('click', function () { var i = curIdx(); thumbs[(i + 1) % thumbs.length].click(); });
    box.appendChild(prev);
    box.appendChild(next);
  }

  function initNotifyMe() {
    var oos = document.querySelector('.pdp__outstock');
    if (!oos) return;
    var host = oos.parentNode;
    if (!host || host.querySelector('.pdp__notify')) return;
    var form = document.createElement('form');
    form.className = 'pdp__notify';
    form.setAttribute('data-notify-form', '');
    form.innerHTML = '<div class="pdp__notify-label">Currently sold out — drop your email and we\'ll ping you the moment it\'s back.</div><div class="pdp__notify-row"><input type="email" class="pdp__notify-input" placeholder="your@email.com" required aria-label="Email for restock alert"><button type="submit" class="pdp__notify-btn">Notify me</button></div>';
    host.appendChild(form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      if (!input || !input.value) return;
      var msg = document.createElement('div');
      msg.className = 'pdp__notify-success';
      msg.textContent = "Got it — we'll email you the moment this is back in stock.";
      form.parentNode.replaceChild(msg, form);
    });
  }

  var TRUST_TIPS = {
    'Authorized': 'Beach AI is an authorized dealer for 200+ brands. Full manufacturer warranty applies, same as buying direct.',
    '30-day': 'Return any item within 30 days of delivery. No restocking fee. Return shipping is on us for defective items.',
    'Free 2-day': 'Free standard shipping on orders $49+. Most contiguous-US orders arrive in 2 business days.',
    'Free': 'Free standard shipping on orders $49+. Most contiguous-US orders arrive in 2 business days.',
    'US-based': 'Talk to a real person, US-based, 7 days a week. Phone, chat, or email.'
  };
  function initTrustTooltips() {
    document.querySelectorAll('.pdp__bb-trust-item').forEach(function (el) {
      if (el.hasAttribute('data-tip')) return;
      var strong = el.querySelector('strong');
      if (!strong) return;
      var key = strong.textContent.trim();
      var tip = TRUST_TIPS[key];
      if (!tip) { var first = key.split(/\s+/)[0]; tip = TRUST_TIPS[first]; }
      if (tip) { el.setAttribute('data-tip', tip); el.setAttribute('tabindex', '0'); }
    });
  }

  // Real-time "Order in Xh Ym to ship today" countdown
  function initShipsCountdown() {
    var deliveryEl = document.querySelector('.pdp__bb-delivery-body');
    if (!deliveryEl) return;
    if (deliveryEl.querySelector('.pdp__ships-countdown')) return;
    var cfg = window.__pdpShipCutoff || { hour: 17, tz: 'America/New_York' };
    var node = document.createElement('div');
    node.className = 'pdp__ships-countdown';
    deliveryEl.appendChild(node);
    function update() {
      var now = new Date();
      var et = new Date(now.toLocaleString('en-US', { timeZone: cfg.tz }));
      var cutoff = new Date(et.getFullYear(), et.getMonth(), et.getDate(), cfg.hour, 0, 0);
      var day = et.getDay();
      var isWeekend = day === 0 || day === 6;
      if (isWeekend || et >= cutoff) {
        node.innerHTML = '<span class="pdp__ships-countdown__ico" aria-hidden="true">📦</span> Order now to ship the next business day';
        return;
      }
      var msLeft = cutoff - et;
      var hLeft = Math.floor(msLeft / 3600000);
      var mLeft = Math.floor((msLeft % 3600000) / 60000);
      var timeStr = hLeft > 0 ? hLeft + 'h ' + mLeft + 'm' : mLeft + 'm';
      node.innerHTML = '<span class="pdp__ships-countdown__ico" aria-hidden="true">⏱</span> Order in <strong>' + timeStr + '</strong> to ship today';
    }
    update();
    setInterval(update, 60000);
  }

  function init() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(bindWishlist);
    document.querySelectorAll('[data-pdp-liveshoppers]').forEach(bindLiveShoppers);
    syncStockPill();
    var mo = new MutationObserver(syncStockPill);
    document.querySelectorAll('[data-stock]').forEach(function (row) { mo.observe(row, { childList: true, subtree: true, characterData: true }); });
    initMobileAtcBar();
    initHoverZoom();
    initGalleryArrows();
    initNotifyMe();
    initTrustTooltips();
    initShipsCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
